import { render, staticRenderFns } from "./UpdateTherapyInfo.vue?vue&type=template&id=717ced16&"
import script from "./UpdateTherapyInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateTherapyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports